import React, {useState, useContext, useEffect} from 'react'
import { useHistory, useParams } from 'react-router'
import './exploreuser.sass'
import { useSelector, useDispatch } from 'react-redux'
import { starUser, unStarUser, isStarred } from "../../api/social"
import { DarkModeContext } from '../../global/Theme'
import { getUserByUsername } from '../../api/auth'
import { ProfileCardViewerRemote } from '../../components/profile'
import { getUserImagePosts, getUserVideoPosts } from '../../api/feed'
import {EmptyScreen} from '../../components/common/EmptyScreen'
import { FeedCard } from '../../components/feed'


export default function ExploreUser() {

    const {username} = useParams();
    // const history = useHistory();
    const dispatch = useDispatch()
    const { isDark } = useContext(DarkModeContext);
    const [id, setId] = useState("");
    const [reduxImagePosts, setReduxImagePosts] = useState([])
    const [reduxVideoPosts, setReduxVideoPosts] = useState([])
    const [userDataStore, setUserDataStore] = useState(null)
    const [isLoaded, setIsLoaded] = useState(false);
    const [starred, setStarred] = useState(0);
    const history = useHistory();
    const [isMobile, setIsMobile] = useState(true);
    const [width, setWidth] = useState(document.body.clientWidth);
    const [scrollToPost, setSScrollToPost] = useState(true);

    const updateWindowWidth = () => {
        setWidth(document.body.clientWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', updateWindowWidth);
        updateView(width);
        if(width < 850){
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
    }, [width])

    const getIsStarred = async () => {
        const res = await isStarred(userDataStore);
        if (res) setStarred(1)
        else setStarred(2);
    }

    const updateView = (v) => {
        if (v <= 580) {
            document.getElementById('mainWrapper').classList.remove('padding')
            document.getElementById('mainWrapper').classList.add('zero-p')
            // document.getElementById('mobileNav').style.display = "none"
            document.getElementById('custom-header').style.margin = '-70px -10px 0px -10px'
        }
        else {
            if(v < 850 && document.getElementById('custom-header')){
                document.getElementById('custom-header').style.margin = '0'
            }
            document.getElementById('mainWrapper').classList.add('padding')
            document.getElementById('mainWrapper').classList.remove('zero-p')
            document.getElementById('mobileNav').style.display = "none"
        }
    }

    useEffect(() => {
        getUserData();
        
    }, [])


    useEffect(() => {
        if (userDataStore !== null) {
            setId(userDataStore.id)
            getIsStarred();
            
        }
    }, [userDataStore])

    useEffect(() => {
        if(isLoaded){
            document.getElementById('profile-connection-card').style.display = 'none';
            const connectionCard = document.querySelectorAll('.profile-connection-row')
            connectionCard.forEach(card => {
                card.style.display = 'none';
            })
        }
    }, [isLoaded])

    const sleep = async (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms))
    }

    const handleStarUser = async () => {
        if (starred == 1) {
            await unStarUser(userDataStore.id)
            
            dispatch({
                type: 'SET_NOTIFICATION', payload: {
                    isEnabled: true,
                    text: `Unstarred ${userDataStore.username}`,
                    icon: 'notifcomment.svg'
                }
            })
            await sleep(3000)
            dispatch({
                type: 'SET_NOTIFICATION', payload: {
                    isEnabled: false,
                    text: '',
                    icon: ''
                }
            })
            
        } else {
            await starUser(userDataStore.id)
            dispatch({
                type: 'SET_NOTIFICATION', payload: {
                    isEnabled: true,
                    text: `Starred ${userDataStore.username}`,
                    icon: 'notifcomment.svg'
                }
            })
            await sleep(3000)
            dispatch({
                type: 'SET_NOTIFICATION', payload: {
                    isEnabled: false,
                    text: '',
                    icon: ''
                }
            })
        }
        getIsStarred();
    }
    
    const getUserData = async () => {
        const res = await getUserByUsername(username)
        setUserDataStore(res);
        setIsLoaded(true);
    }

// this useEffect being used for getting posts
    let temp = [];
    let videoTemp = [];
    useEffect(() => {
        console.log('started loading post')
        if (userDataStore !== null) {
            console.log('loading the posts')
            getUserImagePosts(userDataStore.id, (imagePostObserver) => {
                temp = [];
                for(var i = 0; i < imagePostObserver.docs.length; i++){
                    temp.push(imagePostObserver.docs[i].data());
                }
                setReduxImagePosts(temp);

            });

            getUserVideoPosts(userDataStore.id, (videoPostObserver) => {
                videoTemp = [];
                for(var i = 0; i < videoPostObserver.docs.length; i++){
                    videoTemp.push(videoPostObserver.docs[i].data());
                }
                setReduxVideoPosts(videoTemp);

            })

        }
    }, [userDataStore])

    const [postObject, setPostObject] = useState({})

    useEffect(() => {
        setPostObject(history.location.state)
    }, [])

    useEffect(() => {
        console.log("first time rendered")
        if(reduxImagePosts){
            if(reduxImagePosts.length > 0){
                // const postObject = history.location.state
                console.log('our postobject is', postObject)
                if(postObject && postObject.postId && (postObject.type == 'img' || postObject.type == '1')){
                    if(document.getElementById(`${postObject.postId}`)){
                        const post = document.getElementById(`${postObject.postId}`).getBoundingClientRect();
                        const navbar = document.getElementById('explore-col-R').getBoundingClientRect();
                        const top =  post.top - 90;
                        if(scrollToPost){
                            if(isMobile){
                                window.scrollTo({
                                    left: 0,
                                    top: top,
                               //     behavior: "smooth",
                                })
                                setSScrollToPost(false)
                            } else {
                                window.scrollTo({
                                    left: 100,
                                    top: top,
                                //    behavior: "smooth",
                                })
                                setSScrollToPost(false)
                            }
                        }
                    } else {
                    }
                } else {
                }
            } else {
            }
        } else {
        }
    }, [reduxImagePosts])


    // for videos
    useEffect(() => {
        if(reduxVideoPosts){
            if(reduxVideoPosts.length > 0){
                const postObject = history.location.state
                if(postObject && postObject.postId && (postObject.type == 'mp4' || postObject.type == '2')){
                    if(document.getElementById(`${postObject.postId}`)){
                        // console.log('scrolling motherfucker')
                        const post = document.getElementById(`${postObject.postId}`).getBoundingClientRect();
                        const navbar = document.getElementById('explore-col-R').getBoundingClientRect();
                        // console.log('top of the post video is ', post.top)
                        const top =  post.top - 90;
                        if(scrollToPost){
                            window.scrollTo(0, top)
                            setSScrollToPost(false);
                        }
                    }
                }
            }
        }
    }, [reduxVideoPosts])

    return (
        <div style={{width: '100%'}} id='mobile-view-exploreuser'>
            {
                            !isMobile ? 
                            "" :
                            <div className={`${isDark ? 'profile-name-card-dark' : 'profile-name-card-light'}`} id='custom-header' style={{marginTop: '1px', zIndex: '100', marginBottom: '10px'}}>
                                <img style={{ zIndex: '2' }} alt="goback" onClick={() => { history.goBack() }} src={require('../../assets/icons/backbutton.svg')}  />
                                <p>{(userDataStore != null) ? `${userDataStore.username}'s Posts` : ''}</p>
                                <img style={{ zIndex: '2' }} alt="star" onClick={handleStarUser} src={starred != 0 ? starred == 2 ? require('../../assets/icons/star.svg') : require('../../assets/icons/star_a.svg') : null}  />
                            </div> 
            }
            {
                isLoaded && userDataStore != null && <div className='explore-user-wrapper' id='explore-user-wrapper'>
                    <div className='explore-col-L' id='explore-col-L'>
                        <div className='explore-col-L-wrapper'>
                            <div className={`${isDark ? 'profile-name-card-dark' : 'profile-name-card-light'}`}>
                                <img style={{ zIndex: '2' }} onClick={() => { history.goBack() }} alt="goback" src={require('../../assets/icons/backbutton.svg')}  />
                                <p>{userDataStore.username}</p>
                                <img style={{ zIndex: '2' }} alt="star" onClick={handleStarUser} src={starred != 0 ? starred == 2 ? require('../../assets/icons/star.svg') : require('../../assets/icons/star_a.svg') : null}  />
                            </div>
                            <ProfileCardViewerRemote userDataStore={userDataStore} />
                        </div>
                    </div>
                    <div className='explore-col-R' id='explore-col-R'>

                        {
                            (reduxImagePosts && reduxImagePosts.length === 0) ? 
                            <EmptyScreen logo="home_a" description="Follow or subscribe Lovrs to start seeing the photos and videos they share" heading="Welcome to LOVR Online" btntext="Explore LOVR" /> :
                            reduxImagePosts.map((v) => {
                                {/* console.log(v) */}
                                return <FeedCard key={v.id} likeMap={v.whoLiked} bookmarkMap={v.whoBookmarked} commentMap={v.whoCommented} postId={v.id} user={v.user} username={userDataStore.username} location={v.location} userImage={userDataStore.image}  image={v.media} placeholder={v.placeholder} body={v.body} likesCount={v.likesCount} commentsCount={v.commentsCount} time={v.time} type={v.type} />
                            })
                        }
                        {
                            (reduxVideoPosts && reduxVideoPosts.length === 0) ? 
                            '':
                            reduxVideoPosts.map((v) => {
                                {/* console.log(v) */}
                                return <FeedCard key={v.id} user={v.user} likeMap={v.whoLiked} bookmarkMap={v.whoBookmarked} commentMap={v.whoCommented} postId={v.id} username={userDataStore.username} location={v.location} userImage={userDataStore.image}  image={v.media} placeholder={v.placeholder} body={v.body} likesCount={v.likesCount} commentsCount={v.commentsCount} time={v.time} type={v.type} />
                            })
                        }
                    </div>
                </div>
            }    
        </div>
    )

}

// userThumb={v.user.thumbnail}
